module.exports = __webpack_public_path__ + "static/media/shreyas.166eb9fb.png";